import constructMetaObject from './constructMetaObject'
import groupBy from 'lodash.groupby'
import applyToOneOrMany from './applyToOneOrMany'

export default function transformProject (data) {
	return applyToOneOrMany(_transformProject, data)
}

function _transformProject (post) {
	post.lang = post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch'


	if (post.polylang.translations) {
		const firstAlternateLanguage = Object.keys(post.polylang.translations)[0]
		post.alternateLanguage = {
			lang: firstAlternateLanguage === 'en' ? 'en-us' : 'de-ch',
			slug: post.polylang.translations[firstAlternateLanguage].slug
		}
	} else {
		post.alternateLanguage = {
			lang: post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch',
			slug: post.slug
		}
	}

	post.featuredImageUrl = post.featured_image ? post.featured_image.sizes.bandara_medium : ''
	post.featuredImageAlt = post.featured_image && post.featured_image.alt ? post.featured_image.alt : 'Featured Image'

	post.facts = post.project_facts_repeater

	if (post.related_projects_repeater && post.related_projects_repeater.length) {
		post.relatedProjects = post.related_projects_repeater.map((x) => x.related_project['ID'])
	}

	return post
}



// WEBPACK FOOTER //
// ./src/api/util/transformProject.js